<template>

<div class="container-center">
    <TopModule></TopModule>
    <router-view/>
    <Footer class="am-margin-vertical-sm" :html="context"></Footer>
  </div>
</template>

<script>
export default {
  name: 'App',
  data(){
    return{
      context:''
    }
  },
  created(){
    this.context = this.$ajax.get({action: 'Index',typeId:'port40',rowNum:'1',contextFlg:'2'})[0].dt[0].context
  }
}
</script>

<style>

html,body{
  background-image: url("~@/assets/images/bg.gif");
  background-repeat: repeat-x;
  background-position: top;
  background-color: white;
}
.container-center {
    width: 980px;
    margin: 0 auto;
    padding: 5px;
    background-color: white;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue